import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import axios from 'axios';
import { addLocaleData } from 'react-intl';
import nl from 'react-intl/locale-data/nl';
import fr from 'react-intl/locale-data/fr';

import './index.scss';
import './index.css';

import './polyfills/';

import App from './app';
import registerServiceWorker from './registerServiceWorker';
import setupAxios from './config/axios';
import store from './redux/store/store';
import { checkLanguage, fetchLanguages } from './redux/head/headActions';

// setup axios once for the whole application
setupAxios();

addLocaleData(nl);
addLocaleData(fr);

store.dispatch(checkLanguage());
store.dispatch(fetchLanguages());

ReactDOM.render(
	<Provider store={store}>
		<App />
	</Provider>
	, document.getElementById('root')
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js